// @ts-check
/**
 * @prettier
 */

import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';
import PropTypes from 'prop-types';
import _values from 'lodash/values';
import { getCardSettings } from 'cards/util/cardSettingsUtils';

import { priceFormatter } from '../../../../../components/product/PricingUtils';
import ShopItemCard from './components/ShopItemCard';

import {
  getCustomizations,
  getRSVPCustomizationDisabled,
} from '../../../../selectors/cardProjectSelector';
import { getSubtotal } from '../../../../selectors/Customization';

import styles from './WeddingShopItemsModal.module.less';
// @ts-ignore
import icons from './icons.module.less';

const WeddingShopItemsModal = ({
  onGoToCheckoutClick,
  customizations,
  subTotal,
  rsvpCustomizationDisabled,
  shopItemCards = [],
}) => {
  const [currentTotal, setCurrentTotal] = useState(0);
  let customizationsArray = _values(customizations);
  if (rsvpCustomizationDisabled)
    customizationsArray = customizationsArray.filter(c => c.type !== 'RSVP');
  return (
    <section className={styles.modal}>
      <div className={styles.ctaBoxContainer}>
        <div className={styles.ctaBox}>
          <div className={styles.texts}>
            <p className={styles.addedToCart}>
              <i className={icons.check} />
              &nbsp;
              {customizationsArray
                .map(
                  ({ type, quantity }) =>
                    `${quantity} ${
                      getCardSettings(type).label === 'Envelope'
                        ? 'Envelopes'
                        : getCardSettings(type).label
                    }`
                )
                .join(', ')}
              &nbsp;Added To Cart
            </p>
            <p className={styles.subTotal}>
              Subtotal: {priceFormatter((subTotal + currentTotal) / 100)}
            </p>
          </div>
          <div className={styles.cta}>
            <ButtonV2 onClick={onGoToCheckoutClick}>Go To Checkout</ButtonV2>
          </div>
        </div>
      </div>
      <h2 className={styles.donTCheckoutWithoutThese}>Don’t check out without these!</h2>
      <div className={styles.shopItemsContainer}>
        {shopItemCards.map(card => (
          <ShopItemCard
            key={card.id}
            card={card}
            onItemAddedToCart={({ totalCents }) => {
              setCurrentTotal(currentTotal + totalCents);
            }}
          />
        ))}
      </div>
    </section>
  );
};

WeddingShopItemsModal.propTypes = {
  shopItemCards: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onGoToCheckoutClick: PropTypes.func.isRequired,
  customizations: PropTypes.shape({}).isRequired,
  subTotal: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  customizations: getCustomizations(state),
  subTotal: getSubtotal(state),
  rsvpCustomizationDisabled: getRSVPCustomizationDisabled(state),
});

export default connect(mapStateToProps)(WeddingShopItemsModal);



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/WeddingShopItemsModal/WeddingShopItemsModal.jsx